// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find-friends .search {
    display: flex;
    position: relative;
    padding: 10px;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
}
.find-friends .search input {
    flex-grow: 1;
    padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./client/pages/friends/views/FindFriends.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".find-friends .search {\n    display: flex;\n    position: relative;\n    padding: 10px;\n    text-align: center;\n    max-width: 600px;\n    margin: 0 auto;\n}\n.find-friends .search input {\n    flex-grow: 1;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
